module.exports = __webpack_public_path__ + "static/calendars-6bd489ff8e0c26b241dc4ae9fb20f1ac.png";